export enum MimeType {
  IMAGE_JPG = "image/jpg",
  IMAGE_JPEG = "image/jpeg",
  IMAGE_PNG = "image/png",
  IMAGE_GIF = "image/gif",
  DOC = "application/msword",
  DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  PDF = "application/pdf", // Added PDF MIME type
}

export const mimeToExtensionMap: Record<MimeType, string> = {
  [MimeType.IMAGE_JPG]: ".jpg",
  [MimeType.IMAGE_JPEG]: ".jpeg",
  [MimeType.IMAGE_PNG]: ".png",
  [MimeType.IMAGE_GIF]: ".gif",
  [MimeType.DOC]: ".doc",
  [MimeType.DOCX]: ".docx",
  [MimeType.PDF]: ".pdf", // Added mapping for PDF
}

export const ALL_ALLOWED_MIME_TYPE_VALUES = Object.values(MimeType)

export const IMAGE_MIME_TYPES = [MimeType.IMAGE_JPG, MimeType.IMAGE_JPEG, MimeType.IMAGE_PNG, MimeType.IMAGE_GIF]
export const IMAGE_MIME_TYPES_WITH_DOC = [...IMAGE_MIME_TYPES, MimeType.DOC, MimeType.DOCX]
export const IMAGE_MIME_TYPES_WITH_PDF = [...IMAGE_MIME_TYPES, MimeType.PDF]
export const IMAGE_MIME_TYPES_WITH_PDF_AND_DOC = [...IMAGE_MIME_TYPES_WITH_DOC, MimeType.PDF]

export const FILE_UPLOAD_TAKES_TIME_MESSAGE =
  "File uploads may take some time to process. If any files do not appear, please refresh the screen."

export const ALLOWED_TYPE_LABEL_IMAGES_WITH_PDF_AND_DOC = "PDF, PNG, JPG or DOC"

/**
 * File extensions that should be opened in a new tab instead of downloaded
 */
export const OPENABLE_EXTENSIONS = new Set(["pdf", "png", "jpg", "jpeg", "gif", "txt", "html"])
